import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { useLocation } from 'react-router';

const navItems = [
  {
    path: '/admin/tenants',
    label: 'テナント一覧',
  },
  {
    path: '/admin/users',
    label: 'ユーザー一覧',
  },
  {
    path: '/admin/analytics',
    label: '利用状況分析',
  },
  {
    path: '/admin/subscriptions',
    label: '課金状況',
  },
];

export default function AdminSideNav(props) {
  const { className, style, ...extraProps } = props;
  const location = useLocation();

  return (
    <div className={classnames('position-fixed px-3 side-nav bg-dark', className)} style={{ zIndex: 1000, bottom: 0, ...style }} {...extraProps}>
      <div className="p-3" style={{ minHeight: 600 }}>
        <ul className="h-100 nav nav-pills flex-column mb-0">
          {
            navItems.map(({ path, label, regExp }) => {
              return (
                <li className="nav-item" key={label}>
                  <Link to={path} className={classnames('nav-link text-white', { 'bg-secondary': location.pathname.match(regExp || path) })}>
                    {label}
                  </Link>
                </li>
              );
            })
          }
        </ul>
      </div>
    </div>
  );
}
